import React, { useEffect, useState } from 'react';
import {
  Badge,
  IconButton,
  Menu,
  List,
  ListItem,
  ListItemText,
  Typography,
  Box
} from '@mui/material';
import {
  NotificationsOutlined as NotificationsIcon,
  PaymentOutlined as PaymentIcon,
  WarningAmberOutlined as WarningIcon
} from '@mui/icons-material';
import axios from 'axios';

function Notifications() {
  const [notifications, setNotifications] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const fetchNotifications = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/notifications`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setNotifications(response.data);
    } catch (error) {
      console.error('Error al cargar notificaciones:', error);
    }
  };

  useEffect(() => {
    fetchNotifications();
    const interval = setInterval(fetchNotifications, 300000); // Actualizar cada 5 minutos
    return () => clearInterval(interval);
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMarkAsRead = async (notificationId) => {
    try {
      const token = localStorage.getItem('token');
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/api/notifications/${notificationId}`,
        { read: true },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      fetchNotifications();
    } catch (error) {
      console.error('Error al marcar notificación:', error);
    }
  };

  const unreadCount = notifications.filter(n => !n.read).length;

  return (
    <>
      <IconButton 
        onClick={handleClick}
        color="inherit"
      >
        <Badge 
          badgeContent={unreadCount} 
          color="error"
        >
          <NotificationsIcon />
        </Badge>
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            maxHeight: '400px',
            width: '350px',
          },
        }}
      >
        {notifications.length === 0 ? (
          <ListItem>
            <ListItemText primary="No hay notificaciones" />
          </ListItem>
        ) : (
          <List>
            {notifications.map((notification) => (
              <ListItem
                key={notification.id}
                onClick={() => handleMarkAsRead(notification.id)}
                sx={{
                  backgroundColor: notification.read ? 'transparent' : 'action.hover',
                  '&:hover': { backgroundColor: 'action.selected' },
                  borderBottom: '1px solid',
                  borderColor: 'divider'
                }}
              >
                <Box sx={{ mr: 2, color: 'primary.main' }}>
                  {notification.type === 'vencimiento' ? (
                    <WarningIcon />
                  ) : (
                    <PaymentIcon />
                  )}
                </Box>
                <ListItemText
                  primary={
                    <Typography variant="body1">
                      {notification.title}
                    </Typography>
                  }
                  secondary={
                    <Typography variant="body2" color="text.secondary">
                      {notification.message}
                      <br />
                      <Typography component="span" variant="caption" color="text.disabled">
                        {new Date(notification.createdAt).toLocaleString()}
                      </Typography>
                    </Typography>
                  }
                />
              </ListItem>
            ))}
          </List>
        )}
      </Menu>
    </>
  );
}

export default Notifications; 